//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
